import axios from "axios";
import ApiClient from "../http/ApiClient";
import Url from "../http/Url";

const LoginService = {
    getLogin:  async function (data) {
        const res =  await ApiClient.post(Url.Login.CHECK_LOGIN,data);
        // console.log("res :" + res);
        return res;
    },
    getCaptcha: async function (captchaId) {
        try {
            captchaId = captchaId || '0';
           return await ApiClient.get(Url.Login.CAPTCHA +  captchaId);
            // if (response.status === 200) {
            //     return response.data;
            // }
        } catch (error) {
            console.log(error);
        }
        return '0';
    },
}

export default LoginService;